import sellerRegistration from './sellerRegistration'

export default {
	sellerRegistration
}
